var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 13.2522V2.51143C18.5455 1.32995 17.5685 0.363281 16.3744 0.363281H2.26207C1.06795 0.363281 0.0909424 1.32995 0.0909424 2.51143V13.2522C0.0909424 14.4337 1.06795 15.4003 2.26207 15.4003H16.3744C17.5685 15.4003 18.5455 14.4337 18.5455 13.2522ZM6.60431 12.1781V3.5855L13.1177 7.8818L6.60431 12.1781Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeVideo);
export default __webpack_public_path__ + "static/media/type-video.038b8e9f55a132e5f127343de1b35326.svg";
export { ForwardRef as ReactComponent };